module.exports = __webpack_public_path__ + "static/integration/moodlerooms/moodlerooms.f9aa1ca79be43730d4226ca04e03b485.css";